var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellOff({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.994.854a.91.91 0 0 1 1.285 0L4.234 2.81c.935-.64 2.05-.99 3.2-.99h1.132a5.665 5.665 0 0 1 5.665 5.664v3.568c0 .129.044.253.124.354l.545.681a1.7 1.7 0 0 1 .266 1.655l.638.638a.909.909 0 1 1-1.285 1.286l-.823-.822h-.017L2.91 4.074c.003-.002.006-.006.008-.01L.994 2.14a.91.91 0 0 1 0-1.286zm1.291 4.267a5.664 5.664 0 0 0-.516 2.362v3.568c0 .129-.044.253-.124.354l-.545.681a1.7 1.7 0 0 0 1.327 2.761h9.584L2.285 5.121zM5.596 15.98c.35.99 1.295 1.7 2.404 1.7 1.11 0 2.053-.71 2.404-1.7H5.596z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellOff);
export default __webpack_public_path__ + "static/media/bell-off.5c303f6b12cba0786c0bf415a9fae277.svg";
export { ForwardRef as ReactComponent };